import * as actions from '@/constants/actions';
import { apolloClient } from '@/apollo/apollo';
import gql from 'graphql-tag';

export default {
    data() {
        return {
            dataRedistirbute: false,
        };
    },
    // query on mount
    mounted() {
        this.getStationMetadata();
    },
    methods: {
        // get station metadata:
        // - redistribute flag
        async getStationMetadata() {
            if (!this.station) return;
            this.$store.dispatch(actions.ADD_LOADING, 'load station sidebar metadata');
            try {
                const { data } = await apolloClient.query({
                    query: gql`query stationMetadata($id: Int!) {
                        getStation(id: $id) {
                            redistribute
                        }
                    }`,
                    variables: { id: this.station.id },
                });
                this.dataRedistirbute = data.getStation.redistribute;
            } catch (ex) {
                this.$store.dispatch(actions.TRIGGER_TOAST, 'Error retrieving station data');
            } finally {
                this.$store.dispatch(actions.REMOVE_LOADING, 'load station sidebar metadata');
            }
        },
    },
    watch: {
        // query when the station changes
        station() {
            this.getStationMetadata();
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/getStationMetadata.js